"use client";

import { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import tinyhouse from "../assets/images/tiny-house.png";
import universiteit from "../assets/images/universiteit.png";
import villa from "../assets/images/villafinished.png";
import zoo from "../assets/images/zoo.png";
import zwembad from "../assets/images/zwembad.png";
import waterplant from "../assets/images/concreteslabs.png";
import vloerverwarming from "../assets/images/vloer-verwarming.png";
import renovation from "../assets/images/renovation.jpg";
import house from "../assets/images/house.jpg";
import wallrenovation from "../assets/images/wall-renovation.jpg";
import companybuilding from "../assets/images/companybuilding.jpg";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";


function Projects() {
  const { t, i18n } = useTranslation();
  const rawCategories = t("projects.categories", { returnObjects: true });
  const categoryKeys = Object.keys(rawCategories);
  const [activeCategory, setActiveCategory] = useState("all");
  const currentLang = i18n.language;
  const projects = [
    {
      title: t("projects.school.title"),
      category: t("projects.school.category"),
      categoryKey: "healthcare",
      location: t("projects.school.location"),
      year: t("projects.school.year"),
      description: t("projects.school.description"),
      image: universiteit,
    },
    {
      title: t("projects.tinyhouse.title"),
      category: t("projects.tinyhouse.category"),
      categoryKey: "residential",
      location: t("projects.tinyhouse.location"),
      year: t("projects.tinyhouse.year"),
      description: t("projects.tinyhouse.description"),
      image: tinyhouse,
    },
    {
      title: t("projects.swimmingpool.title"),
      category: t("projects.swimmingpool.category"),
      categoryKey: "residential",
      location: t("projects.swimmingpool.location"),
      year: t("projects.swimmingpool.year"),
      description: t("projects.swimmingpool.description"),
      image: zwembad,
    },
    {
      title: t("projects.luxuryhouse.title"),
      category: t("projects.luxuryhouse.category"),
      categoryKey: "residential",
      location: t("projects.luxuryhouse.location"),
      year: t("projects.luxuryhouse.year"),
      description: t("projects.luxuryhouse.description"),
      image: villa,
    },
    {
      title: t("projects.zoo.title"),
      category: t("projects.zoo.category"),
      categoryKey: "industrial",
      location: t("projects.zoo.location"),
      year: t("projects.zoo.year"),
      description: t("projects.zoo.description"),
      image: zoo,
    },
    {
      title: t("projects.waterplant.title"),
      category: t("projects.waterplant.category"),
      categoryKey: "industrial",
      location: t("projects.waterplant.location"),
      year: t("projects.waterplant.year"),
      description: t("projects.waterplant.description"),
      image: waterplant,
    },
    {
      title: t("projects.floorheating.title"),
      category: t("projects.floorheating.category"),
      categoryKey: "residential",
      location: t("projects.floorheating.location"),
      year: t("projects.floorheating.year"),
      description: t("projects.floorheating.description"),
      image: vloerverwarming,
    },
    {
      title: t("projects.renovation.title"),
      category: t("projects.renovation.category"),
      categoryKey: "residential",
      location: t("projects.renovation.location"),
      year: t("projects.renovation.year"),
      description: t("projects.renovation.description"),
      image: renovation,
    },
    {
      title: t("projects.house.title"),
      category: t("projects.house.category"),
      categoryKey: "residential",
      location: t("projects.house.location"),
      year: t("projects.house.year"),
      description: t("projects.house.description"),
      image: house,
    },
    {
      title: t("projects.wallrenovation.title"),
      category: t("projects.wallrenovation.category"),
      categoryKey: "residential",
      location: t("projects.wallrenovation.location"),
      year: t("projects.wallrenovation.year"),
      description: t("projects.wallrenovation.description"),
      image: wallrenovation,
    },
    {
      title: t("projects.companybuilding.title"),
      category: t("projects.companybuilding.category"),
      categoryKey: "commercial",
      location: t("projects.companybuilding.location"),
      year: t("projects.companybuilding.year"),
      description: t("projects.companybuilding.description"),
      image: companybuilding,
    },
  ];

  const filteredProjects =
    activeCategory === "all"
      ? projects
      : projects.filter((project) => project.categoryKey === activeCategory);

  return (
    <>
      <Helmet>
        <title>{t("seo.projects.title")}</title>
        <meta name="description" content={t("seo.projects.description")} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${window.location.origin}/${currentLang}/projects`} />

        <meta property="og:title" content={t("seo.projects.title")} />
        <meta
          property="og:description"
          content={t("seo.projects.description")}
        />
        <meta property="og:url" content={`${window.location.origin}/${currentLang}/projects`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("seo.projects.title")} />
        <meta name="twitter:description" content={t("seo.projects.description")} />
        <meta name="twitter:image" content="path/to/your/image.jpg" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-primary text-white page-header">
        <Container>
          <div style={{ maxWidth: "800px" }}>
            <h1 className="display-4 fw-bold mb-4">
              {t("projects.hero.title")}
            </h1>
            <p className="fs-4 text-white-80">
              {t("projects.hero.description")}
            </p>
          </div>
        </Container>
      </section>

      {/* Projects Filter */}
      <section className="section-padding bg-light">
        <Container>
          <div className="d-flex justify-content-center flex-wrap gap-2 mb-5">
            {categoryKeys.map((key) => (
              <Button
                key={key}
                variant={
                  key === activeCategory ? "tertiary" : "outline-secondary"
                }
                onClick={() => setActiveCategory(key)}
                className="mb-2"
              >
                {rawCategories[key]}
              </Button>
            ))}
          </div>

          <Row className="g-4">
            {filteredProjects.map((project, index) => (
              <Col key={index} md={6} lg={4}>
                <Card className="h-100 shadow">
                  {" "}
                  {/* hover-grow */}
                  <div style={{ height: "250px", position: "relative" }}>
                    <Card.Img
                      variant="top"
                      src={project.image}
                      alt={project.title}
                      className="img-cover"
                      style={{ height: "100%" }}
                      loading="lazy"
                    />
                    <span className="position-absolute top-0 end-0 bg-tertiary text-white px-3 py-1 m-3 rounded-pill">
                      {project.category}
                    </span>
                  </div>
                  <Card.Body>
                    <Card.Title className="fw-bold">{project.title}</Card.Title>
                    <div className="d-flex justify-content-between text-secondary small mb-3">
                      <span>{project.location}</span>
                      <span>{project.year}</span>
                    </div>
                    <Card.Text className="text-secondary mb-3">
                      {project.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Call to Action */}
      <section className="cta-section section-padding">
        <Container>
          <div className="cta-content">
            <h2>{t("home.cta.title")} </h2>
            <p>{t("home.cta.description")} </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Button
                variant="tertiary"
                size="lg"
                as={Link}
                to={`/${currentLang}/contact`}
              >
                {t("home.cta.buttonQuote")}{" "}
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Projects;
